import '../vendor/clickMenu.js';

export const setupMenu = () => {
  const mainNavToggle = document.querySelector('.mobile-toggle') as HTMLButtonElement;
  const navContent = document.querySelector('.nav-content') as HTMLElement;
  const searchForm = document.querySelector('.search-form') as HTMLElement;
  const searchToggle = document.querySelector('.search-toggle') as HTMLButtonElement;

  if (mainNavToggle) {
    mainNavToggle.addEventListener('click', (e) => {
      e.preventDefault();
      mainNavToggle.classList.toggle('active');
      navContent?.classList.toggle('active');
      if (searchForm && searchForm.classList.contains('active') && searchToggle) {
        searchToggle.click();
      }
    });
  }

  $('.main-nav').clickMenu();
};
